<template lang="html">
  <nav :class="$route.name">
    <div class="left p-4 w-screen flex justify-between">
      <div class="flex">
        <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
          <router-link
            class="pr-4"
            
            :to="{ name: 'furniture' }"
            >
            FVRNITVRE
          </router-link>
        </div>
        <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
          <router-link
            @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')"
            :to="{ name: 'about' }"
            >
            SQVADRA B
          </router-link>
        </div>
      </div>
      <div class="uppercase pagetitle">
        {{ pageTitle }}<span v-if="imgCounter" class="pl-4 opacity-40">{{ imgCounter }}</span>
      </div>
    </div>

    <div class="middle p-4 w-screen flex justify-between">
      <div class="uppercase">
          {{ pageTitle }}<span v-if="imgCounter" class="lg:hidden pl-4 opacity-40">{{ imgCounter }}</span>
      </div>
      <div class="flex">
        <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
          <router-link
            class=""
            :to="{ name: 'furniture' }"
            >
            FVRNITVRE
          </router-link>
        </div>
        <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
          <router-link
            class="pl-4 no-mobile"
            :to="{ name: 'about' }"
            >
            SQVADRA B
          </router-link>
        </div>
      </div>
    </div>

    <div class="right p-4 w-screen flex">
      <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
        <router-link
          class="pr-4"
          :to="{ name: 'about' }"
          >
          SQVADRA B
        </router-link>
      </div>
      <div @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')">
        <router-link
          class=""
          :to="{ name: 'furniture' }"
          >
          FVRNITVRE
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["site"]),
  data() {
    return {
      pageTitle: "",
      imgCounter: "",
    }
  },
  mounted() {
    this.$root.$on('pageTitle', this.changeTitle)
    this.$root.$on('imgCounter', this.changeCounter)
  },
  methods: {
    changeTitle(payload) {
      this.pageTitle = payload;
    },
    changeCounter(payload) {
      this.imgCounter = payload;
    }
  }
};
</script>
